import styled from "styled-components";

const ShadowRadius = 5;

export const ThumbnailImg = styled.img`
	width: 100%;
	border-radius: 20px;
	box-shadow: 0px 0px ${ShadowRadius}px black;
	transition-duration: 0.2s;
	position: relative;

	&:hover {
		box-shadow: 0px 0px ${ShadowRadius * 2}px gray;
	}
`;

export const ThumbnailContainer = styled.div`
	position: relative;
`;

export const SuggestedVideoContainer = styled.div`
	margin: ${ShadowRadius}px;
`;

export const VideoTitle = styled.p`
	font-size: 20px;
	margin: 5px 0px;
	color: black;
`;

export const VideoDescriptionContainer = styled.div`
	height: 20px;
	margin: 3px 0px;
	display: flex;
`;

export const DescriptionText = styled.p`
	color: gray;
	margin: 0px;
`;

export const LockOverlay = styled.div`
	display: flex;
	justify-content: center;
	background-color: #00000066;
	border-radius: 20px;
	position: absolute;
	top: 0px;
	bottom: 4px;
	left: 0px;
	right: 0px;
	transition-duration: 0.5s;
	color: gray;

	&::after {
		content: "unlock";
		position: absolute;
		top: calc(50%);
		font-size: min(2.5vw, 50px);

		@media only screen and (max-width: 720px) {
			font-size: 7vw;
		}
	}

	&:hover {
		background-color: #ffffffdd;
		color: white;
		cursor: pointer;
	}
`;

export const LockImg = styled.img`
	opacity: 0.7;
	position: absolute;
	height: 50%;
	margin: auto;
	top: 5px;
	bottom: 5px;
`;
